// extracted by mini-css-extract-plugin
export default {"instructionsSection":"InstructionsSection_instructionsSection__r7dpQ","anchor":"InstructionsSection_anchor__8WfZ-","sectionContent":"InstructionsSection_sectionContent__pDQd3"};